interface CalculateAutoColumnsArgs {
  containerWidth: number;
  columnsBasis: number;
  itemSpacing: number;
}

export const calculateAutoColumns = ({
  containerWidth,
  columnsBasis,
  itemSpacing
}: CalculateAutoColumnsArgs) => {
  if (containerWidth < columnsBasis) {
    return 1;
  }

  const autoColumns = Math.floor(
    (containerWidth + itemSpacing) / (columnsBasis + itemSpacing)
  );

  return Math.max(autoColumns, 1);
};
